import { Column } from "@tento-ui/component-builtin";
import type { BlogSiteIntro } from "../blog-data";
import type {
  BlogIndexRoute,
  BlogPage,
} from "../blog-variant";
import "@tento-ui/brand/blog/blog-minimal-list-view";
import { BlogMinimalListView } from "@tento-ui/brand/blog/blog-minimal-list-view";

export function makeMinimalRoute(intro: BlogSiteIntro): BlogIndexRoute {
  let $list: Option<BlogMinimalListView> = null;

  const makeListProps = (
    props: BlogPage.Props,
    delegate: BlogPage.Delegate,
  ): BlogMinimalListView.Props => ({
    posts: props.posts,
    displayCount: props.displayCount,
    searchQuery: props.searchQuery,
    onSeeMore: delegate.onSeeMore,
    onCardClick: delegate.onCardClick,
  });

  return {
    make(props: BlogPage.Props, delegate: BlogPage.Delegate): HTMLElement {
      const $root = Column.make();
      $root.assignStyles({
        maxWidth: "var(--max-width, 840px)",
        margin: "0 auto",
        padding: "60px var(--brand-inline-padding, 40px) 80px",
        boxSizing: "border-box",
      });

      const $intro = Column.make();
      $intro.classList.add("hero");
      $intro.assignStyles({ gap: "0px" });

      const $name = document.createElement("h1");
      $name.className = "hero-title";
      $name.textContent = intro.name;

      const $bio = document.createElement("p");
      $bio.className = "hero-subtitle";
      $bio.textContent = intro.bio;

      $intro.append($name, $bio);

      const $hr = document.createElement("hr");
      $hr.assignStyles({
        border: "none",
        borderTop: "1px solid var(--divider)",
        margin: "32px 0",
        width: "100%",
      });

      const $heading = document.createElement("h2");
      $heading.className = "section-title";
      $heading.textContent = "Blog";

      $list = BlogMinimalListView.makeWith(makeListProps(props, delegate));

      $root.append($intro, $hr, $heading, $list);
      return $root;
    },
    bind(pagelet: HTMLElement, props: BlogPage.Props, delegate: BlogPage.Delegate): HTMLElement {
      $list?.bind(makeListProps(props, delegate));
      return pagelet;
    },
  };
}
